import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69bd5bfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href"]

import { computed, onMounted } from 'vue'
import { isExternal as isExternalLink } from '../../utils/validate'

// 在Vue3的<script setup>中，defineProps是编译器宏，不需要导入
interface Props {
  iconClass: string // 这个属性会自动映射到kebab-case的icon-class
  className?: string
}

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    iconClass: null,
    className: null
  },
  setup(__props: any) {

const props = __props as {
  iconClass: string // 这个属性会自动映射到kebab-case的icon-class
  className?: string
}




const isExternal = computed(() => {
  return isExternalLink(props.iconClass)
})

const iconName = computed(() => {
  const name = `#icon-${props.iconClass}`
  return name
})

const svgClass = computed(() => {
  if (props.className) {
    return 'svg-icon ' + props.className
  } else {
    return 'svg-icon'
  }
})

const styleExternalIcon = computed(() => {
  return {
    mask: `url(${props.iconClass}) no-repeat 50% 50%`,
    '-webkit-mask': `url(${props.iconClass}) no-repeat 50% 50%`
  }
})

return (_ctx: any,_cache: any) => {
  return (_unref(isExternal))
    ? (_openBlock(), _createElementBlock("div", _mergeProps({
        key: 0,
        style: _unref(styleExternalIcon),
        class: "svg-external-icon svg-icon"
      }, _ctx.$attrs), null, 16))
    : (_openBlock(), _createElementBlock("svg", _mergeProps({
        key: 1,
        class: _unref(svgClass),
        "aria-hidden": "true"
      }, _ctx.$attrs), [
        _createElementVNode("use", { "xlink:href": _unref(iconName) }, null, 8, _hoisted_1)
      ], 16))
}
}

})